import { QueryClientProvider } from '@tanstack/react-query';
import { FC } from 'react';
import { GrowthBookProvider } from '@growthbook/growthbook-react';

import { Router } from 'Router';

import { queryClient } from 'config/reactQuery';
import { NotificationProvider } from 'utils/notification/NotificationProvider';
import featureFlag from './service/featureFlag';
import './style.css';

export const App: FC = () => (
  <QueryClientProvider client={queryClient}>
    <GrowthBookProvider growthbook={featureFlag.gb}>
      <NotificationProvider>
        <Router />
      </NotificationProvider>
    </GrowthBookProvider>
  </QueryClientProvider>
);
